import { ChevronDown } from "lucide-react";
import DropDown from '../../assets/drop-down.svg'
const ModuleCard = ({ module }) => {
  return (
    <div className="flex flex-col gap-4 border-b-[0.5px] border-b-[#878A8E] bg-[#F5F5F5] px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-8 sm:py-4 2xl:py-5 2xl:pl-[42px] 2xl:pr-[62px]">
      <div className="flex min-w-0 flex-col gap-4 sm:flex-row sm:items-center sm:gap-6 2xl:gap-12">
        <div className="flex shrink-0 flex-col items-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FF663633] sm:h-[78px] sm:w-[78px]">
            <img src={module.icon} alt="icon" />
          </div>
          <span className="mt-2 text-sm font-bold leading-4 sm:mt-[11px]">
            Module {module.id}
          </span>
        </div>

        <div className="min-w-0">
          <h4 className="text-lg font-bold leading-[23px] sm:text-[20px]">
            {module.title}
          </h4>
          <p className="mt-2 text-base leading-[21px] sm:mt-[13px] sm:text-lg">
            {module.description}
          </p>
        </div>
      </div>

      <img
        src={DropDown}
        alt="expand module"
        className="h-[22px] w-[22px] shrink-0 self-end sm:self-auto"
      />
    </div>
  );
};

export default ModuleCard;